// Canonical list of Dubai communities / areas used for all address entry.
export const DUBAI_AREAS = [
  "Al Barsha",
  "Al Barsha South",
  "Al Furjan",
  "Al Garhoud",
  "Al Jaddaf",
  "Al Karama",
  "Al Mizhar",
  "Al Nahda",
  "Al Qusais",
  "Al Quoz",
  "Al Rashidiya",
  "Al Safa",
  "Al Satwa",
  "Al Sufouh",
  "Al Warqa",
  "Arabian Ranches",
  "Bluewaters Island",
  "Bur Dubai",
  "Business Bay",
  "City Walk",
  "Deira",
  "Discovery Gardens",
  "DAMAC Hills",
  "Downtown Dubai",
  "Dubai Creek Harbour",
  "Dubai Design District (d3)",
  "Dubai Festival City",
  "Dubai Healthcare City",
  "Dubai Hills Estate",
  "Dubai Internet City",
  "Dubai Investment Park (DIP)",
  "Dubai Marina",
  "Dubai Media City",
  "Dubai Production City (IMPZ)",
  "Dubai Silicon Oasis",
  "Dubai Sports City",
  "Dubai Studio City",
  "Emirates Hills",
  "International City",
  "Jebel Ali",
  "Jumeirah",
  "Jumeirah Beach Residence (JBR)",
  "Jumeirah Golf Estates",
  "Jumeirah Islands",
  "Jumeirah Lake Towers (JLT)",
  "Jumeirah Park",
  "Jumeirah Village Circle (JVC)",
  "Jumeirah Village Triangle (JVT)",
  "Al Kifaf",
  "Living Legends",
  "Meadows",
  "Meydan",
  "Mirdif",
  "Motor City",
  "Mudon",
  "Nad Al Sheba",
  "Palm Jumeirah",
  "Port Rashid",
  "Ras Al Khor",
  "Remraam",
  "Sheikh Zayed Road",
  "Springs",
  "The Gardens",
  "The Greens",
  "The Lakes",
  "The Views",
  "Town Square",
  "Umm Suqeim",
  "Za'abeel",
];
